// extracted by mini-css-extract-plugin
export var color_picker_wrapper = "mix_colors-module--color_picker_wrapper--fbadc";
export var input_hex_color = "mix_colors-module--input_hex_color--41152";
export var mix_color_picker_wrapper = "mix_colors-module--mix_color_picker_wrapper--5643e";
export var mix_color_result = "mix_colors-module--mix_color_result--c87c1";
export var mix_color_title = "mix_colors-module--mix_color_title--4e3ed";
export var mix_colors_wrapper = "mix_colors-module--mix_colors_wrapper--1c1fd";
export var mix_tool_wrapper = "mix_colors-module--mix_tool_wrapper--a2f6e";
export var react_colorful = "mix_colors-module--react_colorful--8943c";